import { render, staticRenderFns } from "./PartnerCreate2.vue?vue&type=template&id=4db6767c&scoped=true"
import script from "./PartnerCreate2.vue?vue&type=script&lang=js"
export * from "./PartnerCreate2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db6767c",
  null
  
)

export default component.exports